import React from "react";
import { useOutlet, Navigate } from "react-router-dom";
import { useAuth } from "../Hooks/AuthContext";
import { isEmpty } from "lodash";
const ProtectedLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  if (user === null || isEmpty(user)) {
    return <Navigate to="/" />;
  }

  return <React.Fragment>{outlet}</React.Fragment>;
};

export default ProtectedLayout;
